import { ControlCodes } from '@bcube/shared/constants';
import { motion } from 'framer-motion';
import { useParams } from 'react-router';
import { UpsertPriceTableForm } from '@/components/forms/commercial/price-table';
import { useAuth } from '@/context/auth-context';

export function PriceTableClonePage() {
  const { id } = useParams<{ id: string }>();
  const { restrictFeatureByProfile } = useAuth();

  const canCreate = restrictFeatureByProfile(ControlCodes.commercial_price_table_create);

  if (!canCreate) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <h1 className="text-2xl font-bold text-foreground">Acesso negado</h1>
        <p className="mt-2 text-muted-foreground">
          Você não tem permissão para clonar tabelas de preços.
        </p>
      </div>
    );
  }

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <UpsertPriceTableForm priceTableId={id} editMode cloneMode />
    </motion.div>
  );
}
